import React, { Fragment } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { StickableTanstackTable } from 'components/common/Table/StickableTanstackTable';
import classNames from 'classnames/bind';
import i18n from 'i18next';
import { Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { renderColumn } from 'components/TableColumn/TableColumn';
import {
  CampaignListState,
  CampaignListProps,
  CampaignListType
} from './CampaignListModel';
import { CampaignListColumns } from './CampaignListColumnSetting';
import {
  faPencilAlt,
  faChartArea,
  faEye,
  faCut,
  faBalanceScaleLeft,
  faTrashAlt,
  faDollarSign
} from '@fortawesome/free-solid-svg-icons';
import styles from './campaignList.module.scss';
import { SearchBar } from 'components/common/SearchBar';
import Progress from 'components/common/Progress/Progress';
import { LoadingIndicator } from 'components/common/LoadingIndicator';
import { Modal } from 'components/common/Modal/Modal';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import PermissionChecker from 'containers/PermissionChecker/PermissionChecker';
import { Permission } from 'core/auth/Permission';
import {
  addOnEnabled,
  hasTheseRoles,
  hasFuncs,
  isRoles,
  inCondition,
  isPmax3Order,
  notSettleOrder,
  notArchivedChannel
} from 'core/permission/PermissionDSL';
import IconWithTooltip from 'components/IconWithTooltip/IconWithTooltip';
import TableRowToolBar from 'containers/TableRowToolBar/TableRowToolBar';
import { ObjectFitContainer } from 'components/common/ObjectFitContainer/ObjectFitContainer';
import _ from 'lodash';
import { Status } from 'components/Status/Status';
import {
  CampaignState,
  RtbCampaignPlanType,
  isOneForAllAdType
} from 'core/rtbCampaign/RtbCampaign';
import { PermissionItem, RoleNames } from 'core';
import { ADDONFEATURE } from 'core/agency/AddonFeature';
import { formatPrice } from 'helper/CurrencyHelper';
import Select from 'components/common/Select/Select';
import { Trans } from 'react-i18next';
import { ListEditBar } from 'components/ListEditBar/ListEditBar';
import { FilterMenuTab } from 'components/common/FilterMenuTab/FilterMenuTab';
import { DraftCreateModal } from 'containers/Draft/DraftCreateModal';
import { BidStrategy } from 'core/l2Object/L2Object';
import { L1ObjectObjective } from 'core/l1Object/L1Object';
import { LimitationTableCell } from 'components/LimitationTableCell/LimitationTableCell';
import { AuditLog } from 'containers/AuditLog/AuditLog';
import {
  StateTableCell,
  StateTableCellWithHint,
  StateTableCellWithIconButton
} from 'components/StateTableCell/StateTableCell';
import { PmpComparingModal } from './PmpComparingModal';
import { getDeliveryTargetCounts } from './deliveryTargetCounts';
import { BidWeightModal } from 'components/GodManagementModal/BidWeightModal';
import { AdminBidPriceModal } from 'components/GodManagementModal/AdminBidPriceModal';
import { renderBidPriceInfo } from 'components/CampaignBidPriceInfo/CampaignBidPriceInfo';
import { ChannelGroupSetting } from 'core/channelGroup/ChannelGroupSettings';

export class CampaignList extends React.Component<
  RouteComponentProps & CampaignListProps,
  CampaignListState
> {
  cssClassNames: any;
  handler?: number;
  columnFormatterMap: any;
  campaignWritePermission: PermissionItem;

  constructor(props) {
    super(props);
    this.state = props.model.state;
    this.cssClassNames = classNames.bind(styles);
    this.campaignWritePermission = hasFuncs(Permission.CAMPAIGN_WRITE)
      .and(
        addOnEnabled(
          ChannelGroupSetting.getAddonNameOfChannel(
            props.model.l1Object.channel
          ) || ADDONFEATURE.CHANNEL[props.model.l1Object.channel]
        )
      )
      .and(isPmax3Order(props.model.order.id))
      .and(notSettleOrder(props.model.order))
      // ECOPD-5566：停用渠道底下的活動列表轉唯讀
      .and(notArchivedChannel(props.model.l1Object.channelGroupId));
    this.columnFormatterMap = {
      [CampaignListColumns.NAME]: this.nameFormatter,
      [CampaignListColumns.STATE]: this.stateFormatter,
      [CampaignListColumns.DELIVERY]: this.deliveryFormatter,
      [CampaignListColumns.CREATIVE]: this.creativeFormatter,
      [CampaignListColumns.SCHEDULE]: this.scheduleFormatter,
      [CampaignListColumns.PROGRESS]: this.progressFormatter,
      [CampaignListColumns.BUDGET]: this.budgetFormatter,
      [CampaignListColumns.PRICE]: this.priceModelFormatter,
      [CampaignListColumns.OPTIMIZE]: this.optimizationFormatter,
      [CampaignListColumns.LIMITATION]: this.limitationFormatter,
      [CampaignListColumns.TRACKING]: this.trackingFormatter,
      [CampaignListColumns.RESULTS]: this.resultsFormatter,
      [CampaignListColumns.IMPRES]: this.descFormatter,
      [CampaignListColumns.VIEWABLE]: this.descFormatter,
      [CampaignListColumns.CLICKS]: this.descFormatter,
      [CampaignListColumns.CPC]: this.performanceDataFormatter.bind(this, 2),
      [CampaignListColumns.CTR]: this.dataPercentFormatter,
      [CampaignListColumns.VCTR]: this.dataPercentFormatter,
      [CampaignListColumns.CONVERT]: this.descFormatter,
      [CampaignListColumns.CPA]: this.performanceDataFormatter.bind(this, 2),
      [CampaignListColumns.CVR]: this.dataPercentFormatter,
      [CampaignListColumns.VIEW]: this.descFormatter,
      [CampaignListColumns.VIEWRATE]: this.dataPercentFormatter,
      [CampaignListColumns.VIEWABLE_VIEWRATE]: this.dataPercentFormatter,
      [CampaignListColumns.UUCOUNT]: this.performanceDataFormatter.bind(
        this,
        0
      ),
      [CampaignListColumns.SPENT]: _.partial(
        formatPrice,
        props.model.order.currency
      ),
      [CampaignListColumns.TAGS]: this.tagsFormatter,
      [CampaignListColumns.EDITBTNS]: this.floatingEditBtnsFormatter
    };
  }

  componentDidMount() {
    this.handler = this.props.model.event.add((model) => {
      this.setState(model.state);
    });
    if (this.props.model.searchString !== '') {
      this.props.model.onSearchChange(this.props.model.searchString);
    }
    if (this.props.model.state.needUpdateViewModelData) {
      this.props.model.updateViewModelData();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.model !== this.props.model) {
      prevProps.model.event.remove(this.handler);
      this.handler = this.props.model.event.add((model) => {
        this.setState(model.state);
      });
    }
    if (this.props.model.state.needUpdateViewModelData) {
      this.props.model.updateViewModelData();
    }
  }

  componentWillUnmount() {
    this.handler && this.props.model.event.remove(this.handler);
  }

  getCampaignEditPermission(campaign) {
    const { l1Object, isPmp } = this.props.model;
    return _.clone(this.campaignWritePermission).and(
      inCondition(
        () =>
          campaign.state !== CampaignState.DELETE &&
          !isPmp(campaign) &&
          l1Object.objective !== L1ObjectObjective.UNSPECIFIED
      )
    );
  }

  nameHeaderFormatter = (column: any, columnIndex: number, { sortElement }) => {
    const model = this.props.model;
    const allSelectableCampaigns = model.state.viewModelData
      ? model.state.viewModelData.filter(
          (viewModelData) => !model.isPmp(viewModelData)
        )
      : model.campaignList.filter((campaign) => !model.isPmp(campaign));
    const allCampaignLength = allSelectableCampaigns.length;
    const selectedObjectsLength =
      model.state.selectedCampaign.length + model.state.selectedDraft.length;
    const isDeletedList = model.state.selectedStateFilter.includes(
      i18n.t('campaignList.labels.deleteState')
    );
    return (
      <div className={styles.nameHeader}>
        <PermissionChecker
          permissionAware={_.clone(this.campaignWritePermission).and(
            inCondition(() => !isDeletedList)
          )}
        >
          <input
            type='checkbox'
            checked={
              allCampaignLength === selectedObjectsLength &&
              selectedObjectsLength > 0
            }
            ref={(el) =>
              el &&
              (el.indeterminate =
                allCampaignLength !== selectedObjectsLength &&
                selectedObjectsLength > 0)
            }
            onChange={model.handleOnSelectAll}
            id={'input0'}
          />
          <label htmlFor='input0' />
        </PermissionChecker>
        {i18n.t(column.text)}
        {sortElement}
      </div>
    );
  };

  nameFormatter = (columnData: any, campaign: any): any => {
    if (columnData.summary) {
      return <div>{columnData.summary}</div>;
    }

    const handleOnSelect = (_e) => {
      this.props.model.handleOnSelect(campaign);
    };

    const renderLabel = () => (
      <span className={styles.campaignName}>{columnData.name}</span>
    );
    const isDraft: boolean = _.get(campaign, 'isDraft', false);
    const campaignId: number = campaign.id;
    const draftId: number = _.get(campaign, 'draftId', 0);
    const objectIsChecked = !isDraft
      ? this.props.model.state.selectedCampaign.indexOf(campaignId) > -1
      : this.props.model.state.selectedDraft.indexOf(draftId) > -1;
    const editPath = campaign.isDraft
      ? `${this.props.match.url}/drafts/${draftId}/${this.props.model.editCampaignPath}`
      : `${this.props.match.url}/campaigns/${campaignId}/${this.props.model.editCampaignPath}`;
    return (
      <div className={styles.campaignCell}>
        <div className={styles.selectCheckBox}>
          <PermissionChecker
            permissionAware={this.getCampaignEditPermission(campaign)}
          >
            <input
              type='checkbox'
              checked={objectIsChecked}
              onChange={handleOnSelect}
              id={`input${columnData.listId}`}
            />
            <label htmlFor={`input${columnData.listId}`} />
          </PermissionChecker>
        </div>
        <div className={styles.info}>
          {isOneForAllAdType(campaign.adType) ? (
            renderLabel()
          ) : (
            <PermissionChecker
              permissionAware={this.getCampaignEditPermission(campaign)}
              renderOtherwise={renderLabel}
            >
              <Link
                to={editPath}
                className={`${styles.campaignName} ${styles.link}`}
              >
                {columnData.name}
              </Link>
            </PermissionChecker>
          )}
          <div className={styles.campaignID}>
            <div>{`ID: ${columnData.listId}`}</div>
            <div>
              <ObjectFitContainer
                key={i18n.language}
                containerHeight={16}
                onlyScaleDown={true}
                alignItems='auto'
                justifyContent='auto'
                margin={0}
              >
                {columnData.typeDes}
              </ObjectFitContainer>
            </div>
            {isDraft && (
              <div className={styles.draftIcon}>
                {i18n.t('l2ObjectList.labels.draft')}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  creativeFormatter = (columnData: any, campaignData: any): any => {
    const clickFunc = () => {
      if (campaignData.draftId) {
        this.props.history.replace(
          `${this.props.location.pathname}?draftIds=${campaignData.draftId}&action=manage`
        );
      } else {
        this.props.history.replace(
          `${this.props.location.pathname}?campaignIds=${campaignData.id}&action=manage`
        );
      }
    };
    const renderCheckButton = () => (
      <IconWithTooltip
        className={styles.detailBtn}
        onClick={clickFunc}
        icon={faEye}
        tooltipProps={{
          id: `campaignListCreativeViewHint-${campaignData.id}`,
          tooltip: i18n.t('campaignList.labels.creativeViewHint')
        }}
      />
    );
    return columnData !== undefined ? (
      <div className={styles.campaignCell}>
        {columnData ? columnData : i18n.t('creativeList.labels.none')}
        <PermissionChecker
          permissionAware={this.getCampaignEditPermission(campaignData)}
          renderOtherwise={renderCheckButton}
        >
          <IconWithTooltip
            placement='right'
            className={styles.campaignEditBtn}
            onClick={clickFunc}
            icon={faPencilAlt}
            tooltipProps={{
              id: `campaignListCreativeEditHint-${campaignData.id}`,
              tooltip: i18n.t('campaignList.labels.creativeEditHint')
            }}
          />
        </PermissionChecker>
      </div>
    ) : (
      <div />
    );
  };

  scheduleFormatter = (columnData: any, _campaign: any): any => {
    return columnData ? (
      <div className={styles.campaignCell}>
        <div className={styles.scheduleContent}>
          <Trans
            i18nKey='campaignList.labels.schedule'
            values={{ start: columnData.start, end: columnData.end }}
            components={{ 1: <br />, 3: <br /> }}
          />
        </div>
      </div>
    ) : (
      <div />
    );
  };

  progressFormatter = (columnData: any): any => {
    return columnData ? (
      <div className={styles.campaignCell}>
        <div className={styles.progressContent}>
          <div className={styles.progress}>
            <Progress
              progress={columnData.executeRate}
              danger={columnData.danger}
              deepWarning={columnData.deepWarning}
              warning={columnData.warning}
            />
          </div>
          {`${columnData.spents} / ${columnData.budget}`}
          <br />
          {`${(columnData.executeRate * 100).toFixed(2)}% / ${(columnData.predictRate * 100).toFixed(2)}%`}
        </div>
      </div>
    ) : (
      <div />
    );
  };

  budgetFormatter = (columnData: any): any => {
    if (columnData.summary) {
      return <div>{columnData.summary}</div>;
    }
    const budgetLabel = columnData.budgetDes ? (
      <>
        {i18n.t('campaignList.labels.budget')}
        <br />
      </>
    ) : undefined;
    const budgetValue = columnData.budgetDes ? (
      <>
        : {columnData.budgetDes}
        <br />
      </>
    ) : undefined;
    return (
      <div className={styles.campaignCell}>
        <div className={styles.budgetContent}>
          <div>
            {budgetLabel}
            {i18n.t('campaignList.labels.distribute')}
            <br />
            {columnData.deliverTypeDes &&
              i18n.t('campaignList.labels.deliverType')}
          </div>
          <div>
            {budgetValue}: {columnData.distributeDes}
            <br />
            {columnData.deliverTypeDes && `: ${columnData.deliverTypeDes}`}
          </div>
        </div>
      </div>
    );
  };

  priceModelFormatter = (priceModel: string): string => {
    return i18n.t(`campaign.labels.${priceModel}`);
  };

  limitationFormatter = (columnData: any, campaignData: any): any => {
    const { channelGroupSetting } = this.props.model;
    const {
      total,
      storeChangeCount,
      weatherCount,
      overBindingLimitCount,
      validCount
    } = getDeliveryTargetCounts(campaignData);
    // 數量是 0 不代表沒設門市：整個縣市選進來、底下門市全部停用時，後端算出來的
    // 分母就是 0 —— 那正是最該看見「投遞中 0 / 原設定 0」的狀況。只要這檔活動真的
    // 鎖了門市／機台就顯示統計卡，沒鎖的活動照舊整區不出現。
    const hasDeliveryTargetLimitation = Object.values(columnData ?? {}).some(
      (items) =>
        Array.isArray(items) && items.some((item) => !!item.deliveryTargetUnit)
    );
    const showDeliveryTargetInfo =
      channelGroupSetting.hasFixedDeliveryTargets() &&
      (total > 0 || hasDeliveryTargetLimitation);

    const deliveryTargetInfo = showDeliveryTargetInfo
      ? {
          validCount,
          totalCount: total,
          deliveryUnit: channelGroupSetting.config.deliveryUnit,
          weatherFilteredCount: weatherCount,
          storeChangeCount,
          overBindingLimitCount,
          deliveryTargetStatuses: campaignData.deliveryTargetStatuses
        }
      : undefined;
    return columnData ? (
      <LimitationTableCell
        summaryData={columnData}
        l2ChannelId={campaignData.id}
        deliveryTargetInfo={deliveryTargetInfo}
      />
    ) : (
      <div />
    );
  };

  trackingFormatter = (columnData: any): any => {
    const renderContent = () => {
      return Object.keys(columnData).map((key) => {
        return <div key={key}>{columnData[key]}</div>;
      });
    };
    return columnData ? (
      <div className={styles.campaignCell}>
        {columnData.conversionTracking ||
        columnData.viewTrackingCodes ||
        columnData.videoProgressTrackingCode ? (
          <Fragment>
            <div className={styles.trackingContent}>{renderContent()}</div>
          </Fragment>
        ) : (
          i18n.t('campaignList.labels.emptyContent')
        )}
      </div>
    ) : (
      <div />
    );
  };

  resultsFormatter = (results, _1, _2, extraData) => {
    if (!results) {
      return <div />;
    }
    return (
      <div className={styles.resultCell}>
        <div className={styles.value}>{results.desc}</div>
        <div className={styles.objective}>{extraData.objective}</div>
      </div>
    );
  };

  performanceDataFormatter = (placement, columnData: any): any => {
    if (!columnData) {
      return <div />;
    }
    if (columnData.summary !== undefined) {
      return <div>{columnData.summary}</div>;
    }
    const value = columnData.value ? columnData.value : 0;
    return (
      <div className={styles.campaignCell}>
        <div className={styles.performanceDataContent}>
          {value.toFixed(placement)}
        </div>
      </div>
    );
  };

  dataPercentFormatter = (columnData: any): any => {
    if (columnData.summary !== undefined) {
      return <div>{`${columnData.summary}%`}</div>;
    }

    return (
      <div className={styles.campaignCell}>
        <div className={styles.performanceDataContent}>
          {`${columnData.value ? columnData.value.toFixed(2) : '0.00'}%`}
        </div>
      </div>
    );
  };

  descFormatter = (columnData: any): any => {
    if (columnData.summary !== undefined) {
      return <div>{`${columnData.summary}`}</div>;
    }

    return (
      <div className={styles.campaignCell}>
        <div className={styles.performanceDataContent}>{columnData.desc}</div>
      </div>
    );
  };

  tagsFormatter = (columnData: any): any => {
    const renderTags = () => {
      return columnData.map((tag) => {
        return <div key={tag}>{tag}</div>;
      });
    };
    return columnData ? (
      <div className={styles.campaignCell}>
        {columnData.length > 0 ? (
          <div className={styles.tagsContent}>{renderTags()}</div>
        ) : (
          i18n.t('campaignList.labels.emptyContent')
        )}
      </div>
    ) : (
      <div />
    );
  };

  optimizationFormatter = (optimize: string, campaign: any): any => {
    const optimization = i18n
      .t(`optimizationGoal.${optimize.toLowerCase()}`)
      .toLowerCase();
    const bidStrategy = _.isNumber(campaign.bidPrice)
      ? BidStrategy.LOWEST_COST_WITH_BID_CAP
      : BidStrategy.LOWEST_COST_WITHOUT_CAP;
    const showOptimization = campaign.priceModel !== RtbCampaignPlanType.FBCPM;
    return (
      <div className={styles.optimizationCell}>
        {showOptimization && (
          <>
            <div className={styles.title}>
              {i18n.t('adSetSetupFlow.mainStep.field.optimizationGoal')}
            </div>
            <div>:</div>
            <div>{optimization}</div>
          </>
        )}
        <div className={styles.title}>
          {i18n.t('adSetSetupFlow.mainStep.field.bidStrategy')}
        </div>
        <div>:</div>
        <div>
          {i18n.t(`l1Object.labels.bidStrategy.${bidStrategy.toLowerCase()}`)}
        </div>
        <div className={styles.title}>
          {i18n.t('adSetSetupFlow.mainStep.field.bidControl')}
        </div>
        <div>:</div>
        <div>
          {renderBidPriceInfo(campaign, this.props.model.order.currency)}
        </div>
        <div className={styles.title}>
          {i18n.t('adSetSetupFlow.mainStep.field.billingEvent')}
        </div>
        <div>:</div>
        <div>
          {campaign.priceModel === RtbCampaignPlanType.RS ||
          campaign.priceModel === 'rb'
            ? i18n.t(
                `rtbCampaign.billingEvent.${campaign.priceModel}.${campaign.optimize.toLowerCase()}`
              )
            : i18n.t(`rtbCampaign.billingEvent.${campaign.priceModel}`)}
        </div>
      </div>
    );
  };

  floatingEditBtnsFormatter = (cell: any, campaign: any): any => {
    const campaignId: number = campaign.id;
    const draftId: number = _.get(campaign, 'draftId', 0);
    const editPath = campaign.isDraft
      ? `${this.props.match.url}/drafts/${draftId}/${this.props.model.editCampaignPath}`
      : `${this.props.match.url}/campaigns/${campaignId}/${this.props.model.editCampaignPath}`;
    const summaryPath = `${this.props.match.url}/campaigns/${campaignId}/summary`;

    const handleShowDeleteConfirmModal = campaign.isDraft
      ? this.showDeleteConfirmModal([], [draftId])
      : this.showDeleteConfirmModal([campaignId], []);
    const handleShowManageBidWeightModal =
      this.showManageBidWeightModal(campaignId);
    const handleShowManageAdminBidPriceModal =
      this.showManageAdminBidPriceModal(campaignId);
    const canDelete = campaign.isDraft
      ? true
      : this.props.model.canDeleteSelectedCampaigns([campaignId]);
    // remove dailyTargetBudget check
    const readonly =
      this.props.model.l1Object.objective === L1ObjectObjective.UNSPECIFIED ||
      isOneForAllAdType(campaign.adType);
    const canCopy = campaign.canNotCopyMessage === '' && !campaign.isDraft;
    const copyMessage = canCopy
      ? i18n.t('campaignList.labels.cloneHint')
      : campaign.canNotCopyMessage;
    const canSplit = campaign.canNotSlitMessage === '' && !campaign.isDraft;
    const splitMessage = canSplit
      ? i18n.t('campaignList.labels.splitHint')
      : campaign.canNotSlitMessage;
    const editMessage = campaign.isDraft
      ? i18n.t('l2ObjectList.labels.editDraft')
      : i18n.t('campaignList.labels.editHint');
    const godModePermissionAware = hasTheseRoles(
      RoleNames.agencyAdmin,
      RoleNames.sysAdmin
    );
    return (
      <TableRowToolBar className={styles.campaignFloatingEditArea}>
        {!readonly && (
          <PermissionChecker
            permissionAware={this.getCampaignEditPermission(campaign)}
          >
            <IconWithTooltip
              icon={faPencilAlt}
              tooltipProps={{
                id: `campaignListEditTip-${campaignId}-${draftId}`,
                tooltip: editMessage,
                link: editPath
              }}
            />
            <IconWithTooltip
              disabled={!canCopy}
              icon={faCopy}
              tooltipProps={{
                id: `campaignListCloneTip-${campaignId}-${draftId}`,
                tooltip: copyMessage,
                link: `${this.props.match.url}/campaigns/${campaignId}/${this.props.model.copyCampaignPath}`
              }}
            />
            {this.props.model.showSplitBtn && (
              <IconWithTooltip
                disabled={!canSplit}
                icon={faCut}
                tooltipProps={{
                  id: `campaignListSplitTip-${campaignId}-${draftId}`,
                  tooltip: splitMessage,
                  link: `${this.props.match.url}/campaigns/${campaignId}/split`
                }}
              />
            )}
          </PermissionChecker>
        )}
        <PermissionChecker permissionAware={hasFuncs(Permission.REPORT_ADS)}>
          <IconWithTooltip
            icon={faChartArea}
            tooltipProps={{
              id: `campaignListReportTip-${campaignId}-${draftId}`,
              link: this.props.model.getReportLink(campaign),
              tooltip: i18n.t('campaignList.labels.reportHint')
            }}
          />
        </PermissionChecker>
        <PermissionChecker
          permissionAware={this.getCampaignEditPermission(campaign)}
        >
          <IconWithTooltip
            disabled={!canDelete}
            onClick={handleShowDeleteConfirmModal}
            icon={faTrashAlt}
            tooltipProps={{
              id: `campaignListCloneTip-${campaignId}`,
              tooltip: canDelete
                ? i18n.t('campaignList.labels.deleteCampaign')
                : i18n.t('campaignList.labels.cannotDelete')
            }}
          />
        </PermissionChecker>
        <PermissionChecker
          permissionAware={_.clone(godModePermissionAware)
            .and(isRoles(RoleNames.agencyAdmin))
            .and(addOnEnabled(ADDONFEATURE.CAMPAIGN.BID_WEIGHT_SETTING))
            .and(this.getCampaignEditPermission(campaign))}
        >
          <IconWithTooltip
            onClick={handleShowManageBidWeightModal}
            icon={faBalanceScaleLeft}
            tooltipProps={{
              id: `campaignListBidWeightTip-${campaignId}-${draftId}`,
              tooltip: i18n.t('campaignList.labels.manageBidWeightModalTitle')
            }}
          />
        </PermissionChecker>
        <PermissionChecker
          permissionAware={_.clone(godModePermissionAware)
            .and(isRoles(RoleNames.agencyAdmin))
            .and(addOnEnabled(ADDONFEATURE.CAMPAIGN.ADMIN_BID_PRICE_SETTING))
            .and(this.getCampaignEditPermission(campaign))
            .and(
              inCondition(
                () =>
                  campaign.bidPrice != null &&
                  this.props.model.manager.checkOptimizeSameAsPriceModel(
                    campaign.priceModel,
                    campaign.optimize
                  ) &&
                  !this.props.model.isPmp(campaign)
              )
            )}
        >
          <IconWithTooltip
            onClick={handleShowManageAdminBidPriceModal}
            icon={faDollarSign}
            tooltipProps={{
              id: `campaignListBidPriceTip-${campaignId}-${draftId}`,
              tooltip: i18n.t('campaignList.hints.manageAdminBidPrice')
            }}
          />
        </PermissionChecker>
        <IconWithTooltip
          icon={faEye}
          tooltipProps={{
            id: `campaignListSummaryTip-${campaignId}`,
            tooltip: i18n.t('campaignList.labels.summaryCampaign'),
            link: summaryPath
          }}
        />
      </TableRowToolBar>
    );
  };

  stateFormatter = (stateData: any): any => {
    return <Status color={stateData.color} label={stateData.des} />;
  };

  deliveryFormatter = (stateData: any, campaign: any): any => {
    const des = stateData.des;
    const isDraft: boolean = _.get(campaign, 'isDraft', false);

    if (isDraft) {
      return (
        <StateTableCell
          stateData={{
            des: i18n.t('campaignList.labels.deactivateState'),
            color: 'black',
            extraInfo: i18n.t('campaignList.labels.draftStateHint')
          }}
        />
      );
    }

    const descriptionToolTipMap = {
      [i18n.t('campaignList.labels.pmpSpacePartialSuspendState')]: {
        id: `campaignListPmpSpacePartialSuspendHint-${campaign.id}`,
        tooltip: i18n.t('campaignList.labels.pmpSpacePartialSuspendHint')
      },
      [i18n.t('campaignList.labels.pmpExpiredState')]: {
        id: `campaignListPmpExpiredHint-${campaign.id}`,
        tooltip: i18n.t('campaignList.labels.pmpExpiredHint')
      }
    };

    const renderHintData =
      des === i18n.t('campaignList.labels.pmpSpacePartialSuspendState')
        ? () => {
            if (
              des === i18n.t('campaignList.labels.pmpSpacePartialSuspendState')
            ) {
              const matchedSpaces = _.get(stateData, 'hintData', []);
              return (
                <>
                  {i18n.t(
                    'campaignList.labels.pmpSpacePartialSuspendHintTitle'
                  )}
                  {_.map(matchedSpaces, (space) => (
                    <div>{space.toString()}</div>
                  ))}
                </>
              );
            }
          }
        : undefined;

    if (renderHintData) {
      return (
        <StateTableCellWithHint
          stateData={stateData}
          hintButtonTooltip={descriptionToolTipMap[des]}
          renderHintData={renderHintData}
        />
      );
    }

    if (campaign.pmp && campaign.originPmp) {
      const showPmpComparingModal = () => {
        this.props.model.setCampaignToViewPmpChanged(campaign);
      };
      return (
        <StateTableCellWithIconButton
          icon={faPencilAlt}
          iconClass={styles.viewPmpChangedButton}
          stateData={stateData}
          buttonTooltip={{
            id: `campaignListPmpChangedHint-${campaign.id}`,
            tooltip: i18n.t('campaignList.labels.pmpChangedHint')
          }}
          onButtonClick={showPmpComparingModal}
        />
      );
    }

    return stateData ? <StateTableCell stateData={stateData} /> : <div />;
  };

  handleNavEvent = (event) => {
    event && event.stopPropagation();
  };

  renderAuditLog = () => {
    const auditLogModel = this.props.model.getAuditLogModel();
    if (!auditLogModel) {
      return <div />;
    }
    return <AuditLog model={auditLogModel} />;
  };

  renderCampaignList = (viewModelData) => {
    const model = this.props.model;
    const rowClasses = (campaign, rowIndex) => {
      let classes: any = null;
      if (rowIndex === 0) {
        classes = styles.summaryRow;
      }

      if (model.isCampaignBudgetRemain(campaign)) {
        classes = [classes, styles.lightDanger].join(' ');
      }
      if (campaign.isDraft) {
        classes = [classes, styles.draftBg].join(' ');
      }

      return classes;
    };

    const columns = model.state.columnsToShow.map((columnToRender) => {
      let column = renderColumn(
        model.getColumnDefinition(columnToRender),
        this.columnFormatterMap[columnToRender]
      );
      if (columnToRender === CampaignListColumns.NAME) {
        column.headerFormatter = this.nameHeaderFormatter;
      }
      return column;
    });
    return (
      <StickableTanstackTable
        stickFirstColumn
        stickLastColumn
        keyField='listId'
        data={viewModelData}
        summaryData={model.state.summaryData}
        columns={columns}
        defaultSorted={[
          {
            dataField: CampaignListColumns.NAME,
            order: 'desc'
          }
        ]}
        rowClasses={rowClasses}
        noDataIndication={i18n.t('campaignList.labels.noData')}
        hidePagination={true}
      />
    );
  };

  renderCreateAndFilter = () => {
    const model = this.props.model;
    const canCreate = model.canCreateCampaign;
    const createContainerClassName = this.cssClassNames(
      'createCampaign',
      'tipContainer',
      {
        block: !canCreate
      }
    );
    return (
      <Fragment>
        {model.l1Object.objective !== L1ObjectObjective.UNSPECIFIED && (
          <PermissionChecker permissionAware={this.campaignWritePermission}>
            <div className={createContainerClassName}>
              {!canCreate && model.canNotCreateMessage && (
                <span className={styles.tooltip}>
                  {model.canNotCreateMessage}
                </span>
              )}
              <Nav.Item>
                <Nav.Link
                  as={Link}
                  to={`${this.props.location.pathname}/campaigns/${model.newCampaignPath}`}
                  disabled={!canCreate}
                  className={`btn btn-tertiary btn-sm ${styles.createCampaignBtn}`}
                >
                  {i18n.t('campaignList.labels.createCampaignBtn')}
                </Nav.Link>
              </Nav.Item>
            </div>
          </PermissionChecker>
        )}
        {model.state.seletedTab !== CampaignListType.AUDIT_LOG && (
          <>
            <FilterMenuTab filterMenuTabConfigs={model.filterMenuTabConfigs} />
            <div className={styles.campaignListTitleFilterArea}>
              <SearchBar
                model={{
                  placeholder: i18n.t('campaignList.placeholders.searchbar'),
                  search: model.handleOnSearch,
                  defaultValue: model.searchString
                }}
              />
            </div>
          </>
        )}
      </Fragment>
    );
  };

  getBatchManageCampaignPath = () => {
    const campaignIds = this.props.model.state.selectedCampaign.join(',');
    const draftIds = this.props.model.state.selectedDraft.join(',');
    let path = `${this.props.location.pathname}?`;
    if (campaignIds) {
      path = path + `campaignIds=${campaignIds}`;
    }
    if (draftIds) {
      path = campaignIds
        ? `${path}&draftIds=${draftIds}`
        : `${path}draftIds=${draftIds}`;
    }
    return path;
  };

  bindCreatives = (event) => {
    event && event.stopPropagation();
    this.props.history.push(`${this.getBatchManageCampaignPath()}&action=bind`);
  };

  activateCreatives = (event) => {
    event && event.stopPropagation();
    this.props.history.push(
      `${this.getBatchManageCampaignPath()}&action=activate`
    );
  };

  addLimitation = (event) => {
    event && event.stopPropagation();
    this.props.history.push(
      `${this.getBatchManageCampaignPath()}&action=addLimitation`
    );
  };

  removeLimitation = (event) => {
    event && event.stopPropagation();
    this.props.history.push(
      `${this.getBatchManageCampaignPath()}&action=removeLimitation`
    );
  };

  batchEditTracking = (event) => {
    event && event.stopPropagation();
    this.props.history.push(
      `${this.getBatchManageCampaignPath()}&action=batchEditTracking`
    );
  };

  batchEditSchedule = (event) => {
    event && event.stopPropagation();
    this.props.history.push(
      `${this.getBatchManageCampaignPath()}&action=batchEditSchedule`
    );
  };

  deactivateCreatives = (event) => {
    event && event.stopPropagation();
    this.props.history.push(
      `${this.getBatchManageCampaignPath()}&action=deactivate`
    );
  };

  renderEditBar = () => {
    const model = this.props.model;
    const showMultiTypeError = !model.allSelectedCampaignSameType();
    const showDraftSelectedError = model.state.selectedDraft.length > 0;
    const hasOneForAllSelected = model.hasSelectedOneForAllCampaign();
    const canDeleteCampaigns = model.canDeleteSelectedCampaigns(
      model.state.selectedCampaign
    );
    const selectedCount =
      model.state.selectedCampaign.length + model.state.selectedDraft.length;
    const canDelete = canDeleteCampaigns && selectedCount > 0;
    const dropdownContainerClassName = this.cssClassNames('tipContainer', {
      block: showMultiTypeError || showDraftSelectedError
    });
    const deleteButtonContainerClassName = this.cssClassNames('tipContainer', {
      block: !canDelete
    });
    const batchEditErrorMessage = showMultiTypeError
      ? i18n.t('campaignList.labels.batchEditMultiTypeError')
      : i18n.t('campaignList.labels.batchEditDraftError');
    const creativeCannotDeleteMessage = i18n.t(
      'campaignList.labels.cannotDelete'
    );
    const handleShowDeleteConfirmModal = this.showDeleteConfirmModal(
      model.state.selectedCampaign,
      model.state.selectedDraft
    );
    const selectedObjects = [
      ...model.state.selectedCampaign,
      ...model.state.selectedDraft
    ];
    const activateDisabledHint = model.getActivateDisabledHint();
    return (
      <ListEditBar
        selectedItems={selectedObjects}
        handleRemoveSelect={model.handleRemoveSelect}
      >
        <div className={dropdownContainerClassName}>
          <div className={styles.tooltip}>{batchEditErrorMessage}</div>
          <ListEditBar.Dropdown
            title={i18n.t('campaignList.labels.batchEdit')}
            id='batchEditAction'
            disabled={
              showMultiTypeError ||
              showDraftSelectedError ||
              hasOneForAllSelected
            }
            onClick={this.handleNavEvent}
          >
            <ListEditBar.SubDropdown
              title={i18n.t('campaignList.labels.creative')}
              id='creativeAction'
              onClick={this.handleNavEvent}
              drop='right'
            >
              <ListEditBar.Dropdown.Item onClick={this.bindCreatives}>
                {i18n.t('campaignList.labels.bindCreative')}
              </ListEditBar.Dropdown.Item>
              <ListEditBar.Dropdown.Item onClick={this.deactivateCreatives}>
                {i18n.t('campaignList.labels.deactivateCreative')}
              </ListEditBar.Dropdown.Item>
              <ListEditBar.Dropdown.Item onClick={this.activateCreatives}>
                {i18n.t('campaignList.labels.activeCreative')}
              </ListEditBar.Dropdown.Item>
            </ListEditBar.SubDropdown>
            <ListEditBar.Dropdown.Item onClick={this.batchEditSchedule}>
              {i18n.t('campaignList.headers.scheduleColumn')}
            </ListEditBar.Dropdown.Item>
            <ListEditBar.SubDropdown
              title={i18n.t('campaignList.labels.limitation')}
              id='limitationAction'
              onClick={this.handleNavEvent}
              drop='right'
            >
              <ListEditBar.Dropdown.Item onClick={this.addLimitation}>
                {i18n.t('campaignList.labels.addLimitation')}
              </ListEditBar.Dropdown.Item>
              <ListEditBar.Dropdown.Item onClick={this.removeLimitation}>
                {i18n.t('campaignList.labels.removeLimitation')}
              </ListEditBar.Dropdown.Item>
            </ListEditBar.SubDropdown>
            <PermissionChecker
              permissionAware={inCondition(() => {
                return (
                  model.l1Object &&
                  model.l1Object.channel === ChannelGroupSetting.RTB.key
                );
              }).and(
                addOnEnabled(
                  ADDONFEATURE.CONVERSION_TRACKING.CONV_TRACKING_LIST
                ).or(addOnEnabled(ADDONFEATURE.CAMPAIGN.THIRDPARTY_TRACKING))
              )}
            >
              <ListEditBar.Dropdown.Item onClick={this.batchEditTracking}>
                {i18n.t('campaignList.headers.trackingColumn')}
              </ListEditBar.Dropdown.Item>
            </PermissionChecker>
          </ListEditBar.Dropdown>
        </div>
        {!_.isEmpty(activateDisabledHint) ? (
          <OverlayTrigger
            placement={'right'}
            trigger={['hover', 'focus']}
            overlay={
              <Tooltip id={'bind-error'}>{activateDisabledHint}</Tooltip>
            }
          >
            <ListEditBar.Item>
              <ListEditBar.Link disabled={true}>
                {i18n.t('campaignList.labels.activeCampaign')}
              </ListEditBar.Link>
            </ListEditBar.Item>
          </OverlayTrigger>
        ) : (
          <ListEditBar.Item>
            <ListEditBar.Link
              disabled={hasOneForAllSelected}
              onClick={model.activeCampaign}
            >
              {i18n.t('campaignList.labels.activeCampaign')}
            </ListEditBar.Link>
          </ListEditBar.Item>
        )}
        <ListEditBar.Item>
          <ListEditBar.Link onClick={model.deactiveCampaign}>
            {i18n.t('campaignList.labels.deactivateCampaign')}
          </ListEditBar.Link>
        </ListEditBar.Item>
        <ListEditBar.Item>
          <ListEditBar.Link
            disabled={hasOneForAllSelected}
            onClick={this.showDraftCreateModal}
          >
            {i18n.t('campaignList.labels.duplicate')}
          </ListEditBar.Link>
        </ListEditBar.Item>
        <div className={deleteButtonContainerClassName}>
          <div className={styles.tooltip}>{creativeCannotDeleteMessage}</div>
          <ListEditBar.Item>
            <ListEditBar.Link
              disabled={!canDelete}
              onClick={handleShowDeleteConfirmModal}
            >
              {i18n.t('campaignList.labels.deleteCampaign')}
            </ListEditBar.Link>
          </ListEditBar.Item>
        </div>
      </ListEditBar>
    );
  };

  showDeleteConfirmModal =
    (campaignIds: number[], draftIds: number[]) => (event?: any) => {
      event && event.stopPropagation();
      this.props.model.setCampaignsToDelete(campaignIds);
      this.props.model.setDraftsToDelete(draftIds);
    };

  showManageBidWeightModal = (campaignId: number) => (event?: any) => {
    event && event.stopPropagation();
    this.props.model.setCampaignToChangeBidWeight(campaignId);
  };

  showManageAdminBidPriceModal = (campaignId: number) => (event?: any) => {
    event && event.stopPropagation();
    this.props.model.setCampaignToChangeAdminBidPrice(campaignId);
  };

  showDraftCreateModal = (event?: any) => {
    event && event.stopPropagation();
    this.props.model.setVisibilityOfDraftCreateModal(true);
  };

  exitDeleteProgress = () => {
    this.props.model.setCampaignsToDelete([]);
    this.props.model.setDraftsToDelete([]);
  };

  hideManageBidWeightModal = () => {
    this.props.model.setCampaignToChangeBidWeight(undefined);
  };

  hideManageAdminBidPriceModal = () => {
    this.props.model.setCampaignToChangeAdminBidPrice(undefined);
  };

  hideDraftCreateModal = (dirty: boolean) => {
    this.props.model.setVisibilityOfDraftCreateModal(false);
    dirty && this.props.model.onCampaignChange();
  };

  hidePmpComparingModal = () => {
    this.props.model.setCampaignToViewPmpChanged(undefined);
  };

  renderDeleteConfirmModal = () => {
    const { deleteCampaignIds, deleteDraftIds } = this.props.model.state;

    const isCampaign = deleteCampaignIds.length > 0;
    const isDraft = deleteDraftIds.length > 0;
    const isMix = isCampaign && isDraft;
    let modalTitle = '';
    let modelContent = '';
    if (isMix) {
      modalTitle = i18n.t('campaignList.labels.mixDeleteModalTitle');
      modelContent = i18n.t('campaignList.labels.mixDeleteModalContent');
    } else if (isCampaign) {
      modalTitle = i18n.t('campaignList.labels.deleteCampaignModalTitle');
      modelContent = i18n.t('campaignList.labels.deleteCampaignModalContent');
    } else {
      modalTitle = i18n.t('campaignList.labels.deleteDraftModalTitle');
      modelContent = i18n.t('campaignList.labels.deleteDraftModalContent');
    }
    return (
      <Modal
        title={modalTitle}
        secondaryButton={{
          title: i18n.t('common.buttons.cancel'),
          callback: this.exitDeleteProgress
        }}
        primaryButton={{
          title: i18n.t('campaignList.labels.deleteCampaign'),
          callback: this.props.model.delete
        }}
        dismiss={this.exitDeleteProgress}
      >
        {_.map(modelContent.split(/\r?\n/), (hint, index) => (
          <div key={index}>{hint}</div>
        ))}
      </Modal>
    );
  };

  renderManageBidWeightModal = () => {
    const campaign = this.props.model.state.viewModelData.find(
      (campaign) =>
        campaign.id === this.props.model.state.campaignToChangeBidWeight
    );

    return (
      <BidWeightModal
        campaign={{
          id: campaign.id,
          magnificationRatio: campaign.magnificationRatio
        }}
        onFinish={this.props.model.onBidWeightUpdated}
        onClose={this.hideManageBidWeightModal}
      />
    );
  };

  renderManageAdminBidPriceModal = () => {
    const campaign = this.props.model.state.viewModelData.find(
      (campaign) =>
        campaign.id === this.props.model.state.campaignToChangeAdminBidPrice
    );
    if (!campaign) {
      return;
    }

    return (
      <AdminBidPriceModal
        campaign={{
          id: campaign.id,
          bidPrice: campaign.bidPrice,
          adminBidPrice: campaign.adminBidPrice
        }}
        onFinish={this.props.model.onAdminBidPriceUpdated}
        onClose={this.hideManageAdminBidPriceModal}
      />
    );
  };

  renderDraftCreateModal = () => {
    const model = this.props.model;
    if (!model.l1Object) {
      return <div />;
    }
    const campaignsToCreateDraft = model.campaignList
      .filter(
        (campaign) =>
          (!campaign.isDraft &&
            campaign.id &&
            model.state.selectedCampaign.includes(campaign.id)) ||
          (campaign.draftId &&
            model.state.selectedDraft.includes(campaign.draftId))
      )
      .map((campaign) => {
        return campaign.isDraft
          ? {
              id: campaign.draftId ? campaign.draftId : 0,
              isDraft: true
            }
          : {
              id: campaign.id ? campaign.id : 0,
              isDraft: false
            };
      });
    return (
      <DraftCreateModal
        order={model.order}
        l1Object={model.l1Object}
        l2ObjectsToCreateDraft={campaignsToCreateDraft}
        onClose={this.hideDraftCreateModal}
      />
    );
  };

  render = () => {
    const model = this.props.model;
    const viewModelData = model.state.viewModelData;
    const selectedObjects = [
      ...model.state.selectedCampaign,
      ...model.state.selectedDraft
    ];
    const hasSelectCampaign = selectedObjects.length > 0;
    return (
      <div className={styles.campaignList}>
        {model.state.loading && <LoadingIndicator />}
        <div className={styles.campaignListTitleBar}>
          {hasSelectCampaign
            ? this.renderEditBar()
            : this.renderCreateAndFilter()}
        </div>
        <div className={styles.contentArea}>
          <div className={styles.metricsOptionsContainer}>
            <Select
              className={styles.metricsOptions}
              options={model.getTabs()}
              name='metricsGroupOptions'
              simpleValue
              value={model.state.seletedTab}
              onChange={model.showTable}
            />
          </div>
          <div className={styles.listContainer}>
            {model.state.seletedTab === CampaignListType.AUDIT_LOG
              ? this.renderAuditLog()
              : this.renderCampaignList(viewModelData)}
          </div>
        </div>
        {model.state.showDraftCreateModal && this.renderDraftCreateModal()}
        {(model.state.deleteCampaignIds.length > 0 ||
          model.state.deleteDraftIds.length > 0) &&
          this.renderDeleteConfirmModal()}
        {model.state.campaignToChangeBidWeight &&
          this.renderManageBidWeightModal()}
        {model.state.campaignToChangeAdminBidPrice &&
          this.renderManageAdminBidPriceModal()}
        {model.state.campaignToViewPmpChanged && (
          <PmpComparingModal
            order={model.order}
            l1Object={model.l1Object}
            campaignData={model.state.campaignToViewPmpChanged}
            onClose={this.hidePmpComparingModal}
            onRefresh={model.onCampaignChange}
          />
        )}
      </div>
    );
  };
}
